import styled from 'styled-components';

export const FooterLink = styled.a`
    padding-right: 14px;
`;

export const Division = styled.hr`
    margin-bottom: 61px;
`;
